import React from 'react';
import { Banner } from '../../common';
import type { InsuranceSummary } from '../../../dtos/patientmr/insurance.dto';
import PayerBadges from './PayerBadges';
import { coverageSummaryLine, lacksActivePrimary } from './insuranceDisplay';

interface CoverageSummaryProps {
  summary?: InsuranceSummary | null;
}

/** One-line coverage summary for the live patient header (PAT-11 / REQ-INS-07). */
export const CoverageSummaryLine: React.FC<CoverageSummaryProps> = ({ summary }) => {
  const line = coverageSummaryLine(summary);
  if (!line) return null;
  return (
    <span className="inline-flex flex-wrap items-center gap-2 text-sm text-slate-600" data-testid="coverage-summary">
      <span>{line}</span>
      <PayerBadges summary={summary} />
    </span>
  );
};

/** Red coverage-gap banner when no primary coverage is in effect today (REQ-INS-07). */
export const CoverageGapBanner: React.FC<CoverageSummaryProps & { onOpenInsurance?: () => void }> = ({ summary, onOpenInsurance }) => {
  if (!lacksActivePrimary(summary)) return null;
  return (
    <Banner
      variant="error"
      title="No active primary coverage"
      data-testid="coverage-gap-banner"
      action={onOpenInsurance ? (
        <button type="button" onClick={onOpenInsurance} className="text-sm font-medium underline">
          Open insurance
        </button>
      ) : undefined}
    >
      Add or update the patient's primary coverage before billing visits.
    </Banner>
  );
};
